import * as angular from 'angular';
import * as _ from 'lodash';
import * as moment from 'moment';
import ComponentController from '../component-controller';
var templateUrl = require('./datetime-range-picker.html');

class DatetimeRangePickerController extends ComponentController {
  startDate: any;
  endDate: any;

  changeCallback: any;

  datepickerStartOptions: any = {
    maxDate: new Date(),
    showWeeks: false,
    maxMode: 'day'
  };

  datepickerEndOptions: any = {
    minDate: this.startDate,
    maxDate: new Date(),
    showWeeks: false,
    maxMode: 'day'
  };

  rangePickerTemplate: string = 'datetimeRangePicker.html';
  rangePickerIsOpen: boolean;

  $onInit = () => {
    this.rangePickerIsOpen = false;
    this.datepickerEndOptions.minDate = this.startDate;
    this.datepickerStartOptions.maxDate = this.endDate;
  };

  getJsDate = (datetimeToChange: any) => moment(datetimeToChange).toDate();

  saveRange = () => {
    this.startDate = moment(this.startDate).startOf('day');
    this.endDate = moment(this.endDate).endOf('day');
    this.datepickerEndOptions.minDate = this.startDate;
    this.datepickerStartOptions.maxDate = this.endDate;
  };

  setPredefinedRange = (rangeName: string) => {
    let start = null;
    switch (rangeName) {
      case 'week':
        start = moment().subtract(7, 'days').startOf('day');
        break;
      case 'month':
        start = moment().subtract(1, 'months').startOf('day');
        break;
      case 'quarter':
        start = moment().subtract(3, 'months').startOf('day');
        break;
      case 'year':
        start = moment().subtract(1, 'years').startOf('day');
        break;
    }
    this.startDate = start;
    this.endDate = moment();
    this.saveRange();
  };
}

angular.module('ciApp').component('datetimeRangePicker', {
  templateUrl,
  bindings: {
    startDate: '<',
    endDate: '<',
    changeCallback: '&'
  },
  controller: [DatetimeRangePickerController]
});



// WEBPACK FOOTER //
// ./common/components/datetime-range-picker/datetime-range-picker.component.ts